import { createSlice } from '@reduxjs/toolkit'
import name from './name'

export const author = createSlice({
  name,
  initialState: {
    author: null,
    contents: {
      items: [],
      meta: null
    },
    authors: [],
    authorsLoaded: false,
    authorLoaded: false
  },
  reducers: {
    setAuthor: (state, { payload }) => {
      state.author = payload
      state.authorLoaded = true
    },
    setAuthorContents: (state, { payload }) => {
      state.contents.items = [...state.contents.items, ...payload.items]
      state.contents.meta = payload.meta
    },
    resetAuthorContents: (state) => {
      state.contents.items = []
      state.contents.meta = null
    },
    setAuthors: (state, { payload }) => {
      state.authors = payload
      state.authorsLoaded = true
    },
    reset: (state) => {
      state.author = null
      state.authorLoaded = false
      state.contents.items = []
      state.contents.meta = null
    }
  }
})

export const { setAuthors, reset, setAuthor, setAuthorContents, resetAuthorContents } = author.actions

export default author.reducer
